/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { usersFileMgmtColumn } from "../../../../components/Shared/Table/Columns";
import { DIALOGOPENFOR } from "../../../../globals/globals";
import { useDeleteUsersFileMgmtMutation, useGetUsersFileMgmtQuery } from "../../../../store/api/admin/adminApiSlice";
import { setBasicDialogOpenFor, setOpenToast } from "../../../../store/helpers/helperReducers";
import { useStoreDispatch } from "../../../../store/hooks";
import { setIsAddNewUserFileMgmt, setSelectedUserFileMgmt } from "../../../../store/api/admin/reducers";
import { initialState } from "../../../../store/api/admin/initialState";
import { useSelector } from "react-redux";
import { userFileMgmtSelector } from "../../../../store/api/admin/selectors";
import { errorMessage } from "../../../../utils/helpers";

export const useDisplayUserFileMgmt = () => {
  const dispatch = useStoreDispatch();
  const { data, isLoading, refetch } = useGetUsersFileMgmtQuery();
  const selectedUserFileMgmt = useSelector(userFileMgmtSelector);
  const [deleteUsersFileMgmt, deleteStatus] = useDeleteUsersFileMgmtMutation();

  const addUserFileMgmt = () => {
    dispatch(setSelectedUserFileMgmt(initialState.selectedUserFileMgmt));
    dispatch(setIsAddNewUserFileMgmt(true));
    dispatch(setBasicDialogOpenFor(DIALOGOPENFOR.USERFILEMGMT));
  };

  const deleteHandler = async (actionName: string) => {
    try {
      let result: any;
      if (!!actionName && actionName.match("delete")) {
        result = await deleteUsersFileMgmt(selectedUserFileMgmt);

        if (result?.error || deleteStatus.isError) throw result?.error;

        dispatch(
          setOpenToast({
            openToast: true,
            toastType: "success",
            message: `The user ${selectedUserFileMgmt.username} has been successfully deleted .`,
          })
        );
        refetch();
      }
    } catch (error) {
      dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error) }));
    }
  };
  return {
    data,
    isLoading,
    refetch,
    usersFileMgmtColumn,
    addUserFileMgmt,
    deleteHandler,
    selectedUserFileMgmt,
  };
};
